import { ALL_BUTTON_POSITION_LIST } from '@/common/manager/position/button-position';
import { getRealizeValue } from '@/common/util/util';
import { handleRequestParams } from '@/common/util/request';
import isPlainObject from 'lodash/isPlainObject';
import { CnDataSourceChange, emitEvent } from '@/common/util/event-name';
export const config = {
    value: 'setDataSourceValue',
    position: ALL_BUTTON_POSITION_LIST,
    action: (config) => {
        const { buttonConfig, urlParamsDataSource, state, _context, recordDataSource, } = config || {};
        const { options } = buttonConfig || {};
        const { dataSourceValues } = options || {};
        if (Array.isArray(dataSourceValues) && dataSourceValues.length > 0) {
            const temp = handleRequestParams(dataSourceValues, {
                urlParamsDataSource,
                recordDataSource: getRealizeValue(recordDataSource) || {},
                state,
            });
            if (isPlainObject(temp) && Object.keys(temp).length > 0) {
                _context?.setState?.(temp);
                emitEvent(CnDataSourceChange);
            }
        }
        return Promise.resolve();
    },
};
